import { useEffect } from 'react';
import { useDocumentPreview } from './useDocumentPreview';
/**
 * Register the ordered documents that the `DocumentPreviewSidebar` can navigate between with its
 * previous/next buttons and the arrow keys, e.g. the document rows of a table.
 */
export const useDocumentPreviewList = (documentIds) => {
    const { setDocumentIds } = useDocumentPreview();
    // Depend on the ids, not the array, so a new array with the same ids does not register it again
    const key = documentIds.join(',');
    useEffect(() => {
        setDocumentIds(key ? key.split(',') : []);
        return () => setDocumentIds([]);
    }, [key, setDocumentIds]);
};
